import * as React from 'react'
import { useIntl } from 'react-intl'
import BedbankSearchTileWalledContent from './BedbankSearchTileWalledContent'
import BedbankSearchTileSignUpButton from './BedbankSearchTileSignUpButton'
import { EmptyObject } from 'lib/object/objectUtils'
import SearchTilePrimaryActionButton from '../shared/SearchTilePrimaryActionButton'
import TextButton from 'LuxKit/Button/TextButton'
import { checkBypassMode } from 'marketing/lib/lib'
import { getAccommodationSearchPrimaryAction } from 'lib/search/accommodationSearchPresentation'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  filters?: App.OfferListFilters
  utmBp?: string
  onSelectDatesClick?: () => void
  hidePricing?: boolean
  hideMemberWalls?: boolean
  isAnytimeSearch?: boolean
  selectDatesOnly?: boolean
}

function BedbankSearchTileAction({
  offer,
  filters = EmptyObject,
  utmBp,
  onSelectDatesClick,
  hidePricing = false,
  hideMemberWalls = false,
  isAnytimeSearch = false,
  selectDatesOnly = false,
}: Props) {
  const intl = useIntl()
  // Only on bedbank titles when bp=2 is set and the user isn't logged in. Clicking on "Login for member savings" triggers the login modal.
  const isLoginForMemberSavings = checkBypassMode(utmBp)
  const hidePrice = hidePricing || !!offer.hidePricing

  const primaryAction = getAccommodationSearchPrimaryAction({
    offerType: offer.type,
    propertyType: offer.propertyType,
    hidePrice,
    isAnytimeSearch,
    canSelectDates: !!onSelectDatesClick,
  })

  const handleSelectDatesClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (primaryAction === 'select-dates' && onSelectDatesClick) {
      e.preventDefault()
      onSelectDatesClick()
    }
  }

  const actionButton = primaryAction === 'select-dates' && onSelectDatesClick ? (
    <TextButton nonInteractable={!selectDatesOnly} fit={selectDatesOnly ? 'full-width' : 'auto'} kind="primary" onClick={handleSelectDatesClick}>
      {intl.formatMessage({
        id: 'qBTPc0sN1iCq7uv1ODCV',
        defaultMessage: 'Select dates',
      })}
    </TextButton>
  ) : (
    <SearchTilePrimaryActionButton />
  )

  if (selectDatesOnly && primaryAction !== 'select-dates') return null

  return <BedbankSearchTileWalledContent
    wall={<BedbankSearchTileSignUpButton isLoginForMemberSavings={isLoginForMemberSavings} />}
    offer={offer}
    filters={filters}
    hidePricing={hidePrice}
    hideMemberWalls={hideMemberWalls}
  >
    {actionButton}
  </BedbankSearchTileWalledContent>
}

export default BedbankSearchTileAction
